import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.string.includes";
import getNavBarSection from './get-nav-bar-section';
import mapMainSectionLinks from './map-main-section-links';
import mapSubSectionGroupItems from './map-subSection-group-items';
import mapSubSectionLinks from './map-subSection-links';
import NavigationBarRecord from '../../../../../records/NavigationBarRecord';
export default function getFatNavItems(fatnavContainer) {
  if (!fatnavContainer || !Array.isArray(fatnavContainer.sections)) {
    return [];
  }

  return fatnavContainer.sections.reduce(function (mainItems, mainSection) {
    // Iterating over 1st level SECTIONS
    var hasMainSectionLinks = Array.isArray(mainSection.links);
    var navBarItem = getNavBarSection(mainSection);

    if (!hasMainSectionLinks && Array.isArray(mainSection.sections)) {
      // subsections available
      var subSectionElements = mainSection.sections;
      var subSectionItems = subSectionElements.reduce(function (subSections, subSection) {
        // Iterating over 2nd level SECTIONS
        if (Array.isArray(subSection.sections)) {
          // subsections available
          var subSectionGroupItems = mapSubSectionGroupItems(subSection.sections);
          subSections.push(subSectionGroupItems);
        } else if (Array.isArray(subSection.links)) {
          // iterate over 2nd level LINKS
          var subSectionLinks = mapSubSectionLinks(subSection.links);
          subSections.push(subSectionLinks);
        }

        return subSections;
      }, []);
      navBarItem.subMenuLinks = subSectionItems;
      navBarItem.fitPage = !mainSection.style.includes('mwf-app-nav-1col');
      mainItems.push(new NavigationBarRecord(navBarItem));
    } else if (hasMainSectionLinks) {
      // iterate over 1st level LINKS
      var navBarItems = mapMainSectionLinks(mainSection.links);
      return mainItems.concat(navBarItems);
    }

    return mainItems;
  }, []);
}